import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import logo from '../../../assets/images/ceba-logo-white-text.png'
import CancelButton from './CancelButton'
import WeMeanBusiness from './WeMeanBusiness'
import {
  Typography,
  Paper,
  TextField,
  Grid,
  Button,
  IconButton,
  InputAdornment,
  MenuItem
} from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  container: {
    height: 'auto'
  },
  header: {
    backgroundColor: '#445765',
    padding: '10px 0 10px 0'
  },
  logo: {
    maxHeight: '80px',
    height: '12vw',
    marginLeft: '10px'
  },
  register: {
    color: 'whitesmoke'
  },
  formContent: {
    padding: '25px'
  },
  wmb: {
    float: 'right'
  }
}))

const BasicInfoForm = ({
    handleChange,
    handleSubmit,
    fields,
    errors,
    international
  }) => {
  const classes = useStyles()
  const [showPass, setShowPass] = useState(false)

  const passMinCharText = (errors) => {
    return(
      errors.passMinCharError ?
        'Please enter a Password with at least eight characters' :
        'Minimum of eight characters'
    )
  }

  const passMatchErrorText = (errors) => {
    return(
      errors.passMatchError ? "Doesn't match Password" : null
    )
  }

  const emailHelperText = (errors) => {
    return(
      errors.invalidEmail ?
        errors.invalidEmail :
        'Your work email helps connect you to your organization on CEBA InterConnect'
    )
  }

  return(
    <Paper elevation={3} className={classes.container}>
      <div className={classes.header}>
        <Grid container>
          <Grid item xs={5} md={4}>
            <img src={logo} className={classes.logo}/>
          </Grid>
          <Grid container item xs={7} md={8} alignItems='center'>
            <Typography
              variant='h5'
              className={classes.register}
            >
              Register for CEBA InterConnect
            </Typography>
          </Grid>
        </Grid>
      </div>
      <form onSubmit={handleSubmit} className={classes.formContent}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name='first_name'
              label='First Name'
              required
              fullWidth
              variant='outlined'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name='last_name'
              label='Last Name'
              required
              fullWidth
              variant='outlined'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name='email'
              label='Work Email'
              value={fields.email}
              disabled={!!gon.invitation}
              required
              error={errors.invalidEmail ? true : false}
              fullWidth
              variant='outlined'
              helperText={emailHelperText(errors)}
              placeholder='i.e. msmith@cebuyers.org'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={international ? 6 : 12}>
            <TextField
              name='notes'
              label='Company'
              value={fields.notes}
              disabled={!!gon.invitation}
              required
              fullWidth
              variant='outlined'
              placeholder='Name of your company'
              onChange={handleChange}
            />
          </Grid>
          {international &&
            <Grid item xs={12} md={6}>
              <TextField
                name='registered_org_type'
                label='Company Type'
                select
                required
                fullWidth
                variant='outlined'
                value={fields.registered_org_type || ''}
                onChange={handleChange}
              >
                <MenuItem value='buyer'>Buyer</MenuItem>
                <MenuItem value='education'>Education</MenuItem>
                <MenuItem value='government'>Government</MenuItem>
                <MenuItem value='ngo'>NGO</MenuItem>
                <MenuItem value='utility'>Utility</MenuItem>
              </TextField>
            </Grid>
          }
          <Grid item xs={12} md={6}>
            <TextField
              name='password'
              label='Password'
              type={showPass ? 'text' : 'password'}
              required
              error={errors.passMinCharError}
              helperText={passMinCharText(errors)}
              fullWidth
              variant='outlined'
              onChange={handleChange}
              InputProps={{
                endAdornment:
                  <InputAdornment position='end'>
                    <IconButton onClick={() => setShowPass(!showPass)}>
                      {showPass ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name='password_confirmation'
              label='Confirm Password'
              type={showPass ? 'text' : 'password'}
              required
              error={errors.passMatchError}
              helperText={passMatchErrorText(errors)}
              fullWidth
              variant='outlined'
              onChange={handleChange}
            />
          </Grid>
          <Grid container item xs={6} justifyContent='flex-end'>
            <Button
              variant='contained'
              color='primary'
              type='submit'
            >
              Submit
            </Button>
          </Grid>
          <Grid item xs={6}>
            <CancelButton />
          </Grid>
        </Grid>
      </form>
      {international &&
        <Grid container item justifyContent='center'>
          <WeMeanBusiness />
        </Grid>
      }
    </Paper>
  )
}

export default BasicInfoForm
